module.exports = __webpack_public_path__ + "1c2d79e7fff3f5b3c06bf4b8e27676bd.jpg";